<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.82404 1.82407H5.89441V5.89444H22.1759V17.088H3.85922V3.85925H1.82404V1.82407ZM5.89441 15.0528H20.1407V7.92963H5.89441V15.0528ZM5.89441 19.1232H8.94719V22.1759H5.89441V19.1232ZM20.1407 19.1232H17.0879V22.1759H20.1407V19.1232Z" fill="currentColor"/>
    </svg>
</template>
